import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            游戏分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-xl mx-auto">
            覆盖多种游戏类型，无论你喜欢刺激的动作冒险还是深度的策略模拟，都能找到心仪之选
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-lg border border-background-200/70 p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {cat.gameCount} 款游戏
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}